import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "d-flex align-center mt-n2 mb-2 flex-wrap justify-space-between"
}
const _hoisted_2 = { class: "d-flex align-center" }
const _hoisted_3 = { class: "d-flex align-center" }

import { storeToRefs } from "pinia";
import { watch } from "vue";

import { ROUTE_ABOUT, ROUTE_INVITE, SETTINGS } from "@/utils/constants";
import WebSocketClient from "@/libs/WebSocketClient";
import { useAppStore, useNetworkStore } from "@/stores";
import {
  useAeppSdk,
  useCurrencies,
  useCommunityFactory,
  useWalletConnect,
} from "@/composables";
import { OpenAPI } from "@/api/generated";

import AppHeader from "@/components/Header/AppHeader.vue";
import CollectInvitationLinkCard from "@/components/Invitation/CollectInvitationLinkCard.vue";
import CountDown from "@/components/CountDown.vue";
import NetworkSelector from "@/components/Header/NetworkSelector.vue";
import CurrencySelector from "@/components/Header/CurrencySelector.vue";
import ConfirmDialog from "@/components/Dialogs/ConfirmDialog.vue";
import TransactionConfirmDialog from "@/components/Dialogs/TransactionConfirmDialog.vue";
import LatestTransactionsCarousel from "@/components/LatestTransactionsCarousel.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const { darkMode, isMobile, isSdkInitialized } = storeToRefs(useAppStore());
const { initSdk, staticAeSdk, getSdk } = useAeppSdk();
const { activeNetwork } = storeToRefs(useNetworkStore());
const { checkWalletConnection } = useWalletConnect();
const { loadAeternityData, loadCurrencyRates } = useCurrencies();
const { getFactory } = useCommunityFactory();

watch(
  activeNetwork,
  async (network, prevNetwork) => {
    if (SETTINGS.showCountdown || !network) {
      return;
    }
    isSdkInitialized.value = false;
    OpenAPI.BASE = `${network.apiUrl}`;
    try {
      await Promise.all([loadAeternityData(), loadCurrencyRates()]);
    } catch (e) {
      console.error("Error loading data", e);
    }
    try {
      await initSdk();
      const sdk = await getSdk();
      sdk.selectNode(network.name);
      staticAeSdk.selectNode(network.name);
      isSdkInitialized.value = true;
      checkWalletConnection();
      getFactory();
    } catch (e) {
      isSdkInitialized.value = false;
      console.error("SDK initialization failed", e);
    }
    if (network?.websocketUrl !== prevNetwork?.websocketUrl) {
      WebSocketClient.disconnect();
      WebSocketClient.connect(network.websocketUrl);
    }
  },
  { immediate: true }
);

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_RouterView = _resolveComponent("RouterView")!
  const _component_v_main = _resolveComponent("v-main")!
  const _component_v_app = _resolveComponent("v-app")!

  return (_unref(SETTINGS).showCountdown)
    ? (_openBlock(), _createBlock(CountDown, { key: 0 }))
    : (_openBlock(), _createBlock(_component_v_app, {
        key: 1,
        class: "app",
        theme: _unref(darkMode) ? 'dark' : 'light'
      }, {
        default: _withCtx(() => [
          _createVNode(AppHeader),
          _createVNode(_component_v_main, { class: "py-0 px-2 px-sm-3 px-md-4 app-main" }, {
            default: _withCtx(() => [
              _createVNode(LatestTransactionsCarousel),
              (_unref(isMobile))
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                      _createVNode(NetworkSelector, { dense: "" }),
                      _createVNode(CurrencySelector, { dense: "" })
                    ]),
                    _createElementVNode("div", _hoisted_3, [
                      _createVNode(_component_v_btn, {
                        to: { name: _unref(ROUTE_ABOUT) },
                        variant: "text",
                        class: "bcl-app-header-options px-2 px-sm-4"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t("blocks.appHeader.about")), 1)
                        ]),
                        _: 1
                      }, 8, ["to"]),
                      _createVNode(_component_v_btn, {
                        to: { name: _unref(ROUTE_INVITE) },
                        variant: "text",
                        class: "bcl-app-header-options px-2 px-sm-4"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t("blocks.appHeader.invite")), 1)
                        ]),
                        _: 1
                      }, 8, ["to"])
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createVNode(CollectInvitationLinkCard),
              _createVNode(_component_RouterView),
              _createVNode(ConfirmDialog),
              _createVNode(TransactionConfirmDialog)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["theme"]))
}
}

})